/* eslint-disable */
// @ts-nocheck

import React, { useEffect, useState } from "react";
import { FormLabel } from "@carbon/react";
import FieldTooltip from "../tooltip/Tooltip";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevron-down.svg";
import { ReactComponent as ChevronUp } from "../../assets/icons/chevron-up.svg";
import useHideComponentonOutsideClick from "../../hooks/useHideComponentonOutsideClick";

interface IProps {
  className?: string;
  titleText?: string;
  placeholder?: string;
  items: Array;
  tooltipText?: string;
  required?: boolean;
  disabled?: boolean;
  selectedItems?: any;
  handleSelection?: any;
  clearSelected?: any;
}

const SearchableMultiSelect = ({
  className,
  titleText,
  placeholder,
  items,
  tooltipText,
  required,
  disabled = false,
  selectedItems,
  handleSelection,
  clearSelected,
}: IProps) => {
  const [searchText, setSearchText] = useState<string>("");
  const [filteredList, setFilteredList] = useState<Array>(items);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useHideComponentonOutsideClick(false);

  useEffect(
    () =>
      setFilteredList([
        ...items.sort((a, b) =>
          a.text < b.text ? -1 : a.text > b.text ? 1 : 0
        ),
      ]),
    [items]
  );
  // data-cy={`${titleText.replaceAll(" ", "")}-input`}
  return (
    <div className="form-wrapper" ref={ref}>
      <div className="form-label">
        <FormLabel data-cy={`${titleText.replaceAll(" ", "")}-textlabel`}>
          {titleText} {required == true ? "*" : null}
        </FormLabel>
        {tooltipText ? (
          <FieldTooltip
            label={tooltipText}
            fieldName={`${titleText.replaceAll(" ", "")}-`}
          />
        ) : null}
      </div>
      <div>
        <div
          className={
            disabled ? "search-container style-1" : "search-container style-2"
          }
        >
          <div
            className={
              disabled
                ? "inactive-controls select-controls"
                : "active-controls select-controls"
            }
          >
            <div data-cy="channelIDScount">{selectedItems?.length ?? 0}</div>
            <button
              type="button"
              onClick={() => clearSelected()}
              disabled={disabled}
              data-cy="clearChannelIDs-button"
            >
              X
            </button>
          </div>
          <input
            data-cy={`${titleText.replaceAll(" ", "")}-input`}
            name={searchText}
            type="text"
            value={searchText}
            placeholder={placeholder}
            className={
              disabled
                ? "searchbar inactive-searchbar"
                : "searchbar active-searchbar"
            }
            onChange={(event: { target: { value: string } }) => {
              setSearchText(event.target.value);
              const result = items.filter((item) =>
                item.text
                  .toLowerCase()
                  .includes(event.target.value.toLowerCase())
              );
              setFilteredList([...result]);
            }}
            disabled={disabled}
            onClick={() => setIsComponentVisible(true)}
          />
          <div>
            {!isComponentVisible ? (
              <div
                className={
                  disabled ? "chevron-down chevron-inactive" : "chevron-active"
                }
              >
                <button type="button" disabled={disabled}>
                  <ChevronDown
                    onClick={() => setIsComponentVisible(true)}
                    data-cy="chevron-down"
                  />
                </button>
              </div>
            ) : (
              <div className={"chevron-down chevron-active"}>
                <button type="button" disabled={disabled}>
                  <ChevronUp
                    onClick={() => setIsComponentVisible(false)}
                    data-cy="chevron-up"
                  />
                </button>
              </div>
            )}
          </div>
        </div>
        <div
          className={
            isComponentVisible ? "active-list list" : "inactive-list list"
          }
        >
          <ul>
            {filteredList?.map((item) => {
              const isSelected =
                selectedItems &&
                selectedItems?.find((obj) => obj.id === item.id)
                  ? true
                  : false;
              return (
                <li
                  key={item.id}
                  onClick={() => handleSelection(item)}
                  className={
                    isSelected ? "active list-item" : "notActive list-item"
                  }
                >
                  <input
                    type="checkbox"
                    onChange={() => handleSelection(item)}
                    checked={selectedItems?.length ? isSelected : false}
                    id={item.id}
                    data-cy={`${titleText.replaceAll(" ", "")}-checkbox`}
                  />
                  <span>{item.text}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SearchableMultiSelect;
